import { DispatcherEvent } from '@carvana/merch-native';
import getSourcedSendMessageToNative from './getSourcedSendMessageToNative';

export default function sendSourcedFavoriteMessageToNative(
  action: 'add' | 'remove',
  payload: { stockNumber: number; vehicleId: number },
  eventSource: string
) {
  return getSourcedSendMessageToNative(eventSource)(
    action === 'add'
      ? DispatcherEvent.FavoriteAdded
      : DispatcherEvent.FavoriteRemoved,
    payload
  );
}
